<template>
  <div v-if="params.hide">
  </div>
  <div v-else class="flex items-center gap-2">
    <!-- Info icon button -->
    <FontAwesomeIcon :icon="['fas','circle-info']" class="w-4 h-4 cursor-pointer" style="color:#3498db" @click.stop="showModal = true"/>

    <!-- Main display text -->
    <span class="truncate">{{ params.displayText }}</span>


    <!-- Modal overlay - teleported to body -->
    <Teleport to="body">
      <div
        v-if="showModal"
        @click="closeModal"
        class="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999]"
      >
        <div
          v-html="params.tooltipContent"
          class="bg-white text-black p-10 rounded-lg overflow-auto"
          @click.stop
        />
      </div>
    </Teleport>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default defineComponent({
  name: 'CC_ToolTip',
  components: {FontAwesomeIcon},
  props: {
  },
  data() {
    return {
      showModal: false
    };
  },
  mounted() {
    // Add escape key listener
    document.addEventListener('keydown', this.handleEscapeKey);
  },
  unmounted() {
    // Clean up event listener
    document.removeEventListener('keydown', this.handleEscapeKey);
  },
  methods: {
    closeModal() {
      this.showModal = false;
    },
    handleEscapeKey(event) {
      if (event.key === 'Escape' && this.showModal) {
        this.closeModal();
      }
    }
  }
});
</script>
